<div class="auth-wrapper auth-v2">
    <div class="auth-inner row m-0">
        <!-- Brand logo-->
        <a class="brand-logo" href="javascript:void(0);">
            <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
            <h2 class="brand-text text-primary ml-1">EUROED</h2>
        </a>
        <!-- /Brand logo-->
        <!-- Left Text-->
        <div class="d-none d-lg-flex col-lg-8 align-items-center" style="padding: 0 !important; margin: 0 !important;">
            <!--<video autoplay muted [muted]="'muted'" loop controls id="myVideo">
                <source src="assets\video\EUROED Promotional Video 2019 - Portuguese Version.mp4" type="video/mp4">
            </video>-->
            <video autoplay loop controls id="myVideo" *ngIf="!isMobileOrTablet;">
                <source src="assets\video\tutorial.mp4" type="video/mp4">
            </video>
        </div>
        <!-- /Left Text-->
        <!-- Login-->
        <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
            <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                <h2 class="card-title font-weight-bold mb-1">Bem-vindo de volta! 👋</h2>
                <p class="card-text mb-2">Estimado cliente, por-favor inicie sessão para continuar</p>
                <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
                    <div class="alert-body">
                        <p>{{ error }}</p>
                    </div>
                </ngb-alert>

                <form class="auth-login-form mt-2" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <label class="form-label" for="login-email">Email</label>
                        <input type="text" formControlName="email" class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.email.errors }" placeholder="oseu@email.com"
                            aria-describedby="login-email" autofocus="" tabindex="1" />
                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                            <div *ngIf="f.email.errors.required">Email é obrigatório</div>
                            <div *ngIf="f.email.errors.email">Email deve ser válido</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="d-flex justify-content-between">
                            <label for="login-password">Password</label>
                        </div>
                        <div class="input-group input-group-merge form-password-toggle">
                            <input [type]="passwordTextType ? 'text' : 'password'" formControlName="password"
                                class="form-control form-control-merge"
                                [ngClass]="{ 'is-invalid error': submitted && f.password.errors }"
                                placeholder="············" aria-describedby="login-password" tabindex="2" />
                            <div class="input-group-append">
                                <span class="input-group-text cursor-pointer"><i class="feather font-small-4" [ngClass]="{
                      'icon-eye-off': passwordTextType,
                      'icon-eye': !passwordTextType
                    }" (click)="togglePasswordTextType()"></i></span>
                            </div>
                        </div>
                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback"
                            [ngClass]="{ 'd-block': submitted && f.password.errors }">
                            <div *ngIf="f.password.errors.required">Password é obrigatório</div>
                        </div>
                    </div>
                    <button [disabled]="loading" class="btn btn-primary btn-block" tabindex="3" rippleEffect>
                        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>Entrar
                    </button>
                </form>
                <p class="text-center mt-2">
                    <span>Esqueceu-se?</span>
                    <a routerLink="/pages/authentication/forgot-password-v2">&nbsp;Recuperar senha</a>
                </p>
                <button class="btn btn-danger btn-block mt-5" routerLink="/" rippleEffect>Continuar sem conta</button>
                <p class="text-center"><i>(Algumas funcionalidades não disponíveis)</i></p>
            </div>
        </div>
        <!-- /Login-->
    </div>
</div>